export const getEmptyMultiInputsRow = () => new Array(1).fill('')
